<template>
  <div>
    <h2>新建调整单</h2>
    <Form :model="showAdjustment" :label-width="140" ref="showAdjustmentForm" :rules="showAdjustment.rules" class="form-style">
      <div>
        <FormItem label="订单号" :label-width="100">
          <Input v-model="showAdjustment.list.orderNo" placeholder="" style="width:400px"></Input>
          <Button type="primary" @click="checkSheetBtn" style="display:inline">查询</Button>
          <div v-show="showAdjustment.tip" class="font-style">订单号不存在，请核查</div>

        </FormItem>
      </div>
      <div v-show="showAdjustment.checkInSelect">
        <FormItem label="入住单" :label-width="100">
          <Select v-model="showAdjustment.order" @on-change="changeOrder" placeholder="请选择" style="width:900px">
            <Option value="S00">请选择</Option>
            <Option v-for="orderItem in orderAdjustmentList" :value="orderItem.checkinId" :key="orderItem.checkinId">状态: {{`${orderItem.status===1?'新建':(orderItem.status===2?'办理入住':(orderItem.status===3?'已退房':'取消'))}`}} | 入住单:{{orderItem.checkinId}} | 房间: {{`${orderItem.roomId}`}}_{{`${orderItem.roomNo}`}}</Option>
          </Select>
        </FormItem>
        <FormItem label="子入住单" :label-width="100">
          <Select v-model="showAdjustment.childOrder" @on-change="changeChildOrder" style="width:900px">
            <Option value="S00">请选择</Option>
            <Option v-for="childOrderItem in childOrderList" :value="childOrderItem.checkinInfoId" :key="childOrderItem.checkinInfoId">子入住单:{{`${childOrderItem.checkinInfoId}`}} | 开始结束日期:{{`${childOrderItem.checkinTime}`}}-{{`${childOrderItem.checkoutTime}`}}</Option>
          </Select>
          <div v-show="showAdjustment.data.notAddAdjust==='checkinInfoCancel'" class="font-style">子入住单已取消，不可调整</div>
          <div v-show="showAdjustment.data.notAddAdjust==='unfinish'" class="font-style">子入住单未结束，请及时取消单重建 或等待结束后再调整</div>
          <div v-show="showAdjustment.data.notAddAdjust==='existAdjust'" class="font-style">该子入住单存在有效的调整单，不可重复建单，请核查</div>
        </FormItem>

        <!-- 建单原因 -->
        <div v-show="showAdjustment.table">
          <FormItem label="建单原因" prop="reason" :label-width="100">
            <Input style="width:900px" v-model="showAdjustment.data.reason" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="500" placeholder=""></Input>
          </FormItem>
        <!-- 价格调整 -->
          <div class="table-style">
            <Row class="top">
              <Col span="8" class="col-style">
                  <h3 class="title-style">原子入住单</h3>
              </Col>
              <Col span="8">
                  <h3 class="title-style">调整为</h3>
              </Col>
              <Col span="8">
                  <h3 class="title-style">差额</h3>
              </Col>
            </Row>
            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>实际开始结束日期: {{showAdjustment.data.orgActualCheckinTime!==null?showAdjustment.data.orgActualCheckin:''}}-{{showAdjustment.data.orgActualCheckoutTime!==null?showAdjustment.data.orgActualCheckout:''}}</div>
              </Col>
              <Col span="8">
                  <DatePicker type="daterange" :clearable="false"  placement="bottom-end" v-model="showAdjustment.adjust.dateArr" placeholder="" @on-change="changeDate"></DatePicker>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{difData}}房晚</div>
              </Col>
            </Row>

            <Row class="top">
              <Col span="8">
                  <div>房费原价: {{(showAdjustment.data.orgRoomPrice/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.roomPrice)" v-model="showAdjustment.adjust.roomPrice"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{housePrice.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>业主优惠: {{(showAdjustment.data.orgOwnerBear/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.ownerBear)" v-model="showAdjustment.adjust.ownerBear"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{ownerBearDiff.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top">
              <Col span="8">
                  <div>Xbed优惠: {{(showAdjustment.data.orgXbedBear/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.xbedBear)" v-model="showAdjustment.adjust.xbedBear"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{xbedDiscount.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>应付: {{(showAdjustment.data.orgShouldPay/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <div>{{shouldPay}}</div>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{shouldPayDiff.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top">
              <Col span="8">
                  <div>OTA佣金: {{(showAdjustment.data.orgChannelCommission/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.channelCommission)" v-model="showAdjustment.adjust.channelCommission"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{channelCommissionDiff.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>渠道活动费: {{(showAdjustment.data.orgOtherChannelExpenses/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.otherChannelExpenses)" v-model="showAdjustment.adjust.otherChannelExpenses"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{otherChannelExpensesDiff.toFixed(2)}}</div>
              </Col>
            </Row>    

            <Row class="top">
              <Col span="8">
                  <div>业主推广费: {{(showAdjustment.data.orgOwnerPromotionExpense/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.ownerPromotionExpense)" v-model="showAdjustment.adjust.ownerPromotionExpense"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{ownerPromotionExpenseDiff.toFixed(2)}}</div>
              </Col>
            </Row>

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>Xbed推广费: {{(showAdjustment.data.orgXbedPromotionExpense/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.xbedPromotionExpense)" v-model="showAdjustment.adjust.xbedPromotionExpense"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{xbedPromotion.toFixed(2)}}</div>
              </Col>
            </Row>  

            <Row class="top">
              <Col span="8">
                  <div>Xbed实收: {{(showAdjustment.data.orgReceivedPrice/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <div>{{receivedPrice}}</div>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{receivedPriceDiff.toFixed(2)}}</div>
              </Col>
            </Row> 

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>结算房费: {{(showAdjustment.data.orgSettlementPrice/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <div>{{accountRoomPay}}</div>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{settlementPriceDiff.toFixed(2)}}</div>
              </Col>
            </Row> 

            <Row class="top">
              <Col span="8">
                  <div>平台服务费: {{(showAdjustment.data.orgPlatformPrice/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <div>{{platformPrice.toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{platformPriceDiff.toFixed(2)}}</div>
              </Col>
            </Row> 

            <Row class="top table-bgcolor">
              <Col span="8">
                  <div>推广费返还: {{(showAdjustment.data.orgPromotionExpenseBack/100).toFixed(2)}}</div>
              </Col>
              <Col span="8">
                  <InputNumber :formatter="limitNumber" :parser="limitNumber" @on-change="changeMoney(showAdjustment.adjust.promotionExpenseBack)" v-model="showAdjustment.adjust.promotionExpenseBack"></InputNumber>
              </Col>
              <Col span="8">
                  <div class="differ-style">{{promotionExpenseBackDiff.toFixed(2)}}</div>
              </Col>
            </Row>
          </div>
                
  
          <FormItem :label-width="100">
            <Button type="primary" @click="submitBtn">确认提交</Button>
          </FormItem>
          </div>
      </div>
    </Form>
  </div>
</template>
<script>
import Utils from "@/utils";
import API from "@/api";
import moment from "moment";
import {STORE_KEY} from "../../constants";
export default {
  created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.env = Utils.findFromLocalStorage("env", "dev");
      this.username = Utils.findFromLocalStorage("vue-username");
    },
  mounted(){
     this.$Notice.config({
      top: 200
    });
  },
  data(){
    const showAdjustmentRules = {     
     reason: (rule, value, callback) => {
        if (!this.showAdjustment.data.reason) {
          return callback(new Error('建单原因不能为空'));
        }
        callback();
      },
    }
    return{
      checkinId:null,
      checkinInfoId:null,
      orderAdjustmentList:[],
      childOrderList:[],
      // 差额
      housePrice:0,
      ownerBearDiff:0,
      xbedDiscount:0,
      handle:0,
      channelCommissionDiff:0,
      otherChannelExpensesDiff:0,
      ownerPromotionExpenseDiff:0,
      xbedPromotion:0,
      promotionExpenseBackDiff:0,
    // 调整时间
      difData:0,
    //  入住单声明
    showAdjustment:{
      childOrder:'S00',
      order:'S00',
      tip:false,
      checkInSelect:false,
      table:false,
      list:{
        orderNo:'',
      },
      adjust:{   
        // dateArr:'',
        roomPrice:'',
        ownerBear:'',
        xbedBear:'',
        channelCommission:'',
        otherChannelExpenses:'',
        ownerPromotionExpense:'',
        xbedPromotionExpense:'',
        promotionExpenseBack:''
      },
      data:{
        reason:'',
      },
      rules:{
        reason:[{required: true, trigger: 'blur', validator: showAdjustmentRules.reason}],
      }
    },
    }
  },
  computed:{
    // 调整前的输入框默认
    orgRoomPrice(){
      const orgRoomPrice=(this.showAdjustment.data.orgRoomPrice/100).toFixed(2)
      return orgRoomPrice
    },

    // 调整后实付
    shouldPay(){
      const shouldPay=(this.showAdjustment.adjust.roomPrice-this.showAdjustment.adjust.ownerBear-this.showAdjustment.adjust.xbedBear).toFixed(2)
      return shouldPay
    },
    //应付差额
    shouldPayDiff(){
      const shouldPayDiff=(this.shouldPay-this.showAdjustment.data.orgShouldPay/100)
      return shouldPayDiff
    },

    // 调整后实收
    receivedPrice(){
      const receivedPrice=(this.shouldPay-this.showAdjustment.adjust.channelCommission-this.showAdjustment.adjust.otherChannelExpenses).toFixed(2)
      return receivedPrice
    },
    //实收差额
    receivedPriceDiff(){
      const receivedPriceDiff=(this.receivedPrice-this.showAdjustment.data.orgReceivedPrice/100)
      return receivedPriceDiff
    },

    //结算房费
    accountRoomPay(){
      const accountRoomPay=(this.showAdjustment.adjust.roomPrice-this.showAdjustment.adjust.ownerBear).toFixed(2)
      return accountRoomPay
    },
    //结算房费差额
    settlementPriceDiff(){
      const settlementPriceDiff=(this.accountRoomPay-this.showAdjustment.data.orgSettlementPrice/100)
      return settlementPriceDiff
    },

    //平台服务费
    platformPrice(){
      const platformPrice=(Math.round(this.accountRoomPay*100*0.07)/100)
      return platformPrice
    },
    //平台服务费差额
    platformPriceDiff(){
      const platformPriceDiff=(Math.round(this.platformPrice*100-this.showAdjustment.data.orgPlatformPrice)/100)
      return platformPriceDiff
    }
  },
  methods:{
    // 限制输入数字位数
    limitNumber(value){
       const reg = /^()*(\d+)\.(\d\d).*$/
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
      } else {
        return ''
      }
    },
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    // 调整时间
    changeDate(daterange){
      this.dateArr = daterange
      const num = new Date(this.dateArr[1]).getTime() - new Date(this.dateArr[0]).getTime();
      const dayDay = num/1000/60/60/24;
      var a = moment(this.showAdjustment.data.orgActualCheckinTime);
      var b = moment(this.showAdjustment.data.orgActualCheckoutTime);
      const dayDayDiff = b.diff(a,'days')
      this.difData =this.showAdjustment.data.orgActualCheckinTime!==null?(dayDay-dayDayDiff-1):(dayDay-0)
    },
    // 调整金额
    changeMoney(){
     this.housePrice  = this.showAdjustment.adjust.roomPrice ? Number.parseFloat(this.showAdjustment.adjust.roomPrice - this.showAdjustment.data.orgRoomPrice/100):0
     this.ownerBearDiff  = this.showAdjustment.adjust.ownerBear ? Number.parseFloat(this.showAdjustment.adjust.ownerBear - this.showAdjustment.data.orgOwnerBear/100):0
     this.xbedDiscount  = this.showAdjustment.adjust.xbedBear ? Number.parseFloat(this.showAdjustment.adjust.xbedBear - this.showAdjustment.data.orgXbedBear/100):0
     this.channelCommissionDiff  = this.showAdjustment.adjust.channelCommission ? Number.parseFloat(this.showAdjustment.adjust.channelCommission - this.showAdjustment.data.orgChannelCommission/100):0
     this.otherChannelExpensesDiff  =this.showAdjustment.adjust.otherChannelExpenses ? Number.parseFloat(this.showAdjustment.adjust.otherChannelExpenses - this.showAdjustment.data.orgOtherChannelExpenses/100):0
     this.ownerPromotionExpenseDiff  = this.showAdjustment.adjust.ownerPromotionExpense ? Number.parseFloat(this.showAdjustment.adjust.ownerPromotionExpense - this.showAdjustment.data.orgOwnerPromotionExpense/100):0
     this.xbedPromotion  = this.showAdjustment.adjust.xbedPromotionExpense ? Number.parseFloat(this.showAdjustment.adjust.xbedPromotionExpense - this.showAdjustment.data.orgXbedPromotionExpense/100):0
     this.promotionExpenseBackDiff  = this.showAdjustment.adjust.promotionExpenseBack ? Number.parseFloat(this.showAdjustment.adjust.promotionExpenseBack - this.showAdjustment.data.orgPromotionExpenseBack/100):0
    },
    //查询按钮
    async checkSheetBtn(){
      if (!this.checkHasPermission('ms_adjustment_searchCheckinByOrderNo')) {
      return;
      }
      this.showAdjustment.checkInSelect = false
      this.showAdjustment.table = false
      this.showAdjustment.order = 'S00'
      this.showAdjustment.childOrder ='S00'
      this.showAdjustment.data.notAddAdjust= false
      this.checkinId = null
      this.checkinInfoId = null
      this.childOrderList = null
      let params = {
       orderNo:this.showAdjustment.list.orderNo||'',
      }
      const resp = (await API.omsAPI[this.env].order.AddAdjustmentOrderNo(
        params,
        this.token
      )).data
      if(resp.retCode){
        this.showAdjustment.tip = true
        this.showAdjustment.checkInSelect = false
        return
      } else {
        this.orderAdjustmentList=resp
        this.showAdjustment.tip = false
        this.showAdjustment.checkInSelect = true
        }
  },
  //改变入住单号
  async changeOrder(checkinId){
     if (!this.checkHasPermission('oms_order_checkinInfo_listByCheckinId')) {
      return;
      }
    if(this.showAdjustment.order !== 'S00'){
      this.checkinId=checkinId
      let params = {
        checkinId:checkinId,
        }
        const resp = (await API.omsAPI[this.env].order.AddAdjustmentListByCheckinId(
          params,
          this.token
        )).data
        if(resp.retCode){
          //  this.$Notice.error({
          //   desc: resp.msg
          // })
          return
        } else {
          this.childOrderList = resp
        }
    } else {
      return
    }
   
  },
  //改变子入住单号
  async changeChildOrder(checkinInfoId) {
    if (!this.checkHasPermission('oms_adjustment_getAdjustmentConsumptions')) {
      return;
      }
    if(this.showAdjustment.childOrder!=='S00'){
      this.difData = 0 
      this.housePrice = 0
      this.ownerBearDiff = 0
      this.xbedDiscount = 0
      this.shouldPayDiff = 0
      this.channelCommissionDiff = 0
      this.otherChannelExpensesDiff = 0
      this.ownerPromotionExpenseDiff = 0
      this.xbedPromotion = 0
      this.receivedPriceDiff = 0
      this.settlementPriceDiff = 0
      this.platformPriceDiff = 0
      this.promotionExpenseBackDiff = 0
      this.checkinInfoId=checkinInfoId
      //  查询列表
      let params = {
        checkinId:this.checkinId,
        checkinInfoId:checkinInfoId,
        orderNo:this.showAdjustment.list.orderNo,
        }
        const resp = (await API.omsAPI[this.env].order.AddAdjustmentListInfo(
          params,
          this.token
        )).data 
        if(resp.retCode){
          //  this.$Notice.error({
          //   // title: '获取调整单列表失败',
          //   desc: resp.msg
          // })
          return
        } else {
          this.showAdjustment.data = resp
          if(this.showAdjustment.data.notAddAdjust){
            this.showAdjustment.table=false
          } else {
            this.showAdjustment.table=true
            this.showAdjustment.adjust.dateArr =[resp.orgActualCheckinTime!==null?moment(resp.orgActualCheckinTime).format('YYYY-MM-DD'):'',resp.orgActualCheckoutTime!==null?moment(resp.orgActualCheckoutTime).format('YYYY-MM-DD'):'']
          //  this.showAdjustment.adjust.dateArr[1] =moment(resp.orgActualCheckoutTime).format('YYYY年MM月DD日')
          this.showAdjustment.adjust.roomPrice =(resp.orgRoomPrice/100).toFixed(2)
          this.showAdjustment.adjust.ownerBear =(resp.orgOwnerBear/100).toFixed(2)
          this.showAdjustment.adjust.xbedBear =(resp.orgXbedBear/100).toFixed(2)
          this.showAdjustment.adjust.shouldPayDiff =(resp.orgShouldPay/100).toFixed(2)
          this.showAdjustment.adjust.channelCommission =(resp.orgChannelCommission/100).toFixed(2)
          this.showAdjustment.adjust.otherChannelExpenses =(resp.orgOtherChannelExpenses/100).toFixed(2)
          this.showAdjustment.adjust.ownerPromotionExpense =(resp.orgOwnerPromotionExpense/100).toFixed(2)
          this.showAdjustment.adjust.xbedPromotionExpense =(resp.orgXbedPromotionExpense/100).toFixed(2)
          this.showAdjustment.adjust.promotionExpenseBack =(resp.orgPromotionExpenseBack/100).toFixed(2)
          this.showAdjustment.data.orgActualCheckin = moment(this.showAdjustment.data.orgActualCheckinTime).format('YYYY年MM月DD日')
          this.showAdjustment.data.orgActualCheckout =  moment(this.showAdjustment.data.orgActualCheckoutTime).format('YYYY年MM月DD日')
          }

        }
    }else{
      return
    }
    
  },
  //确认提交
  async submitBtn(){
     let validResult = false    
      this.$refs.showAdjustmentForm.validate((valid) => {
        validResult = valid
      })
      if (!validResult) {
        return
      }
      //新增调整单
      if (!this.checkHasPermission('oms_adjustment_details')) {
        return;
      }
      if (this.showAdjustment.adjust.roomPrice == null ||this.showAdjustment.adjust.ownerBear == null||this.showAdjustment.adjust.xbedBear== null||this.showAdjustment.adjust.channelCommission== null ||this.showAdjustment.adjust.otherChannelExpenses== null ||this.showAdjustment.adjust.ownerPromotionExpense== null ||this.showAdjustment.adjust.xbedPromotionExpense== null ||this.showAdjustment.adjust.promotionExpenseBack== null) {
          this.$Notice.error({
            title: '调整价格输入值不允许为空',
          })
        return
      }
      if(this.housePrice!==0||this.ownerBearDiff!==0||this.xbedDiscount!==0||this.shouldPayDiff!==0||this.channelCommissionDiff!==0||this.otherChannelExpensesDiff!==0||this.ownerPromotionExpenseDiff!==0||this.xbedPromotion!==0||this.receivedPriceDiff!==0||this.settlementPriceDiff!==0||this.platformPriceDiff!==0||this.promotionExpenseBackDiff!==0){
        let params = {
        checkinId: this.checkinId,
        checkinInfoId: this.checkinInfoId,
        createName: this.username,
        orgCreateName: this.username,
        orgUpdateName: this.username,
        updateName: this.username,
        orderNo: this.showAdjustment.list.orderNo,
        reason: this.showAdjustment.data.reason,        
        roomId: this.showAdjustment.data.roomId,

        actualCheckinTime:this.showAdjustment.adjust.dateArr[0]!==''? moment(this.showAdjustment.adjust.dateArr[0]).format('YYYY-MM-DD'):'',
        actualCheckoutTime:this.showAdjustment.adjust.dateArr[1]!==''? moment(this.showAdjustment.adjust.dateArr[1]).format('YYYY-MM-DD'):'',
        orgActualCheckinTime: this.showAdjustment.data.orgActualCheckinTime!== null?this.showAdjustment.data.orgActualCheckinTime:'',
        orgActualCheckoutTime: this.showAdjustment.data.orgActualCheckoutTime!== null? this.showAdjustment.data.orgActualCheckoutTime:'',
        roomNightDiff: this.difData,

        orgChannelCommission: this.showAdjustment.data.orgChannelCommission,
        channelCommission: Math.round(this.showAdjustment.adjust.channelCommission*100),
        channelCommissionDiff: Math.round(this.channelCommissionDiff*100),

        orgOtherChannelExpenses: this.showAdjustment.data.orgOtherChannelExpenses,
        otherChannelExpenses: Math.round(this.showAdjustment.adjust.otherChannelExpenses*100),
        otherChannelExpensesDiff: Math.round(this.otherChannelExpensesDiff*100),

        orgOwnerBear: this.showAdjustment.data.orgOwnerBear,
        ownerBear: Math.round(this.showAdjustment.adjust.ownerBear*100),
        ownerBearDiff: Math.round(this.ownerBearDiff*100),

        orgOwnerPromotionExpense: this.showAdjustment.data.orgOwnerPromotionExpense,
        ownerPromotionExpense: Math.round(this.showAdjustment.adjust.ownerPromotionExpense*100),
        ownerPromotionExpenseDiff: Math.round(this.ownerPromotionExpenseDiff*100),

        orgPlatformPrice: this.showAdjustment.data.orgPlatformPrice,
        platformPrice:Math.round(this.platformPrice*100),
        platformPriceDiff: Math.round(this.platformPriceDiff*100),

        orgPromotionExpenseBack: this.showAdjustment.data.orgPromotionExpenseBack,
        promotionExpenseBack: Math.round(this.showAdjustment.adjust.promotionExpenseBack*100),
        promotionExpenseBackDiff: Math.round(this.promotionExpenseBackDiff*100),

        orgReceivedPrice: this.showAdjustment.data.orgReceivedPrice,
        receivedPrice: Math.round(this.receivedPrice*100),
        receivedPriceDiff: Math.round(this.receivedPriceDiff*100),

        orgRoomPrice: this.showAdjustment.data.orgRoomPrice,
        roomPrice: Math.round(this.showAdjustment.adjust.roomPrice*100),
        roomPriceDiff: Math.round(this.housePrice*100),

        orgSettlementPrice: this.showAdjustment.data.orgSettlementPrice,
        settlementPrice: Math.round(this.accountRoomPay*100),
        settlementPriceDiff: Math.round(this.settlementPriceDiff*100),

        orgShouldPay: this.showAdjustment.data.orgShouldPay,
        shouldPay: Math.round(this.shouldPay*100),
        shouldPayDiff: Math.round(this.shouldPayDiff*100),

        orgXbedBear: this.showAdjustment.data.orgXbedBear,
        xbedBear: Math.round(this.showAdjustment.adjust.xbedBear*100),
        xbedBearDiff: Math.round(this.xbedDiscount*100),

        orgXbedPromotionExpense: this.showAdjustment.data.orgXbedPromotionExpense,
        xbedPromotionExpense: Math.round(this.showAdjustment.adjust.xbedPromotionExpense*100),
        xbedPromotionExpenseDiff: Math.round(this.xbedPromotion*100),       
      }
      const resp = (await API.omsAPI[this.env].order.addAdjustmentList(
        params,
        this.token
      )).data
      if(resp.retCode){
         this.$Notice.error({
          title: "新建调整单失败",
          desc: resp.msg
        })
        if(resp.data){
          this.showAdjustment.data.notAddAdjust=resp.data.notAddAdjust
        }
        return
       } else {
          this.adjustmentResultId=resp.adjustmentResultId
          if(this.$router){
            this.$router.push({path: "/app/Order/adjustment/adjustmentDetail", query: { adjustmentResultId: this.adjustmentResultId }});
          } else {
            setTimeout(()=>{ window.open(`#/Order/adjustment/adjustmentDetail?adjustmentResultId=${this.adjustmentResultId}`)}, 500)
          }
       }
        
      } else {
        this.$Notice.error({
          title: "无差额，请检查调整信息"
        })
        return
      }
  }
}  
}
</script>
<style lang="scss" scoped>
  .form-style{
    margin-top: 20px;
    .font-style{
      color:red
    }
    .table-style{
      width:1000px;
      border:1px solid rgb(56, 55, 55);
      margin:10px;
      padding:10px;
    }
  }
  .top{
    margin-top: 14px
  }
  .table-bgcolor{
    background: #F7F7F7
  }
</style>





// WEBPACK FOOTER //
// src/pages/adjustment-sheet/add-adjustsheet.vue